import ConfiguratorIframeBlock from './ConfiguratorIframeBlock';

export default ConfiguratorIframeBlock;
